import { dynamicRenderModal } from '../../../utils/dynamicModalRender';
import OrderSplitConfirmModal, {
  ConfirmOrderSplitModalProps,
} from '../components/ConfirmOrderSplitModal';

export function confirmOrderSplitModal({
  orderCode,
  onConfirm,
  isMassAction,
}: ConfirmOrderSplitModalProps) {
  dynamicRenderModal({
    component: ({ onClose }) => (
      <OrderSplitConfirmModal
        isOpen
        onClose={onClose}
        orderCode={orderCode}
        onConfirm={onConfirm}
        isMassAction={isMassAction}
      />
    ),
  });
}
